import Faq from '@/models/Faq'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    faqDetails: null
  },

  mutations: {
    setFaqList(state, faqs) {
      each(faqs, faq => {
        const exist = find(state.list, { id: faq.id })
        if (!exist) {
          state.list.push(new Faq(faq))
        }
      })
    },

    clearFaqList(state) {
      state.list = []
    },

    setFaqListMeta(state, meta) {
      state.listMeta = meta
    },

    setFaqDetails(state, faq) {
      if (faq instanceof Faq) {
        state.faqDetails = faq
      } else {
        state.faqDetails = new Faq(faq)
      }
    },

    clearFaqDetails(state) {
      state.faqDetails = null
    }
  },

  actions: {
    async getFaqs({ commit }, params) {
      const query = Faq.page(params.page || 1).limit(params.limit)
      query.where('is_active', true)
      const res = await query.get(params)

      commit('setFaqList', res.data)
      commit('setFaqListMeta', res.meta)
    }
  }
}
